<template>
  <div id="app">
    <router-view v-if="isRouterAlive" />
  </div>
</template>
<script>
export default {
  name: 'app',

  //自定义
  provide() {
    return {
      reload: this.reload
    }
  },
  data() {
    return {
      //定义状态
      isRouterAlive: true,
    }
  },
  methods: {
    //重置方法
    reload() {
      this.isRouterAlive = false
      this.$nextTick(() => {
        this.isRouterAlive = true
      })
    }
  }

}
</script>
<style>
body {
  margin: 0;
  padding: 0;
  font-size: 14px;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.operate {
  margin-bottom: 10px;
}

.select-state {
  width: 120px;
}

.el-pagination {
  margin: 20px;
}

.el-table .el-table__fixed,
.el-table .el-table__fixed-right,
.el-table .el-table__fixed-left {
  height: 100% !important;
}
</style>